import { render, staticRenderFns } from "./Bando26Fase3.vue?vue&type=template&id=6b4298d6&scoped=true"
import script from "./Bando26Fase3.vue?vue&type=script&lang=js"
export * from "./Bando26Fase3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4298d6",
  null
  
)

export default component.exports